import { render, staticRenderFns } from "./tagTest.vue?vue&type=template&id=1fbd2412&scoped=true&"
import script from "./tagTest.vue?vue&type=script&lang=js&"
export * from "./tagTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbd2412",
  null
  
)

export default component.exports